module.exports = __webpack_public_path__ + "static/media/BR.a12bf77b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/flags/svg/BR.svg
// module id = 519
// module chunks = 0